// extracted by css-extract-rspack-plugin
export default {"Box":"VerifyAttestation-module__Box__CEL64","CopyToClipboardIconButton":"VerifyAttestation-module__CopyToClipboardIconButton__sw2aC"};